import { render } from "./FieldBuilder.vue?vue&type=template&id=c2f7752c&scoped=true"
import script from "./FieldBuilder.vue?vue&type=script&lang=js"
export * from "./FieldBuilder.vue?vue&type=script&lang=js"

import "./FieldBuilder.vue?vue&type=style&index=0&id=c2f7752c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f7752c"]])

export default __exports__